<template lang="pug">
.card.comment-card
	.top-bar
		p {{ card.comment }}
	.content(ref='cardContent')
		p(ref='cardReply') {{ card.reply }}
	p.author-info {{ createdAt }} {{ card.user }}
</template>

<script>
export default {
	name : 'comment-card',

	props : {
		card : {
			type     : [Object, Array],
			required : true,
		}
	},

	data : () => ( {
		isLargeReply : false,
	} ),

	computed : {

		createdAt() {
			// when we get the date, it's handed to us as "June 4, 2019 at 10:03:22 AM UTC-7" so
			// we split it at the "at" inside of it to get our date. -> "June 4, 2019"
			const date = new Date( this.card.createdAt.toDate() );

			const month = date.getMonth() + 1;
			const day   = date.getDate();
			const year  = date.getFullYear().toString().split( '20' )[1];

			return `${month}-${day}-${year}`;
		},

	},
};
</script>

<style lang="scss">

.card.comment-card {
	display: flex;
	flex-flow: column;
	position: relative;

	&::after {
		content: '';
		position: absolute;
		left: 0;
		bottom: 0;
		height: 70px;
		width: 100%;
		background: linear-gradient(180deg, rgba( white, 0% ) 0%, rgba( white, 80%) 60%, rgba( white, 100% ) 80% );
		z-index: 1;
	}

	.top-bar {
		height: 40px;
		padding: 10px 15px 10px 15px;
		background: linear-gradient(180deg, rgba(80, 96, 110, 0) 0%, rgba(80, 96, 110, 0.0298343) 27.62%, rgba(80, 96, 110, 0.0675045) 61.88%, rgba(80, 96, 110, 0.125111) 79.56%, rgba(80, 96, 110, 0.2) 100%);
		width: 100%;

		p {
			text-overflow: ellipsis;
			white-space: nowrap;
			overflow: hidden;
		}
	}

	.content {
		height: 125px;
		width: 100%;
		overflow: hidden;
		padding: 15px;
	}

	.author-info {
		color: $alternateGrey;
		text-transform: uppercase;
		font-weight: 400;
		font-family: 'Josefin Sans', sans-serif;
		padding: 0 15px;
		z-index: 2;
		width: 100%;
		position: absolute;
		bottom: 0;
		left: 0;
	}
}

</style>
